<template>
  <vs-row vs-w="12">
    <vs-col vs-w="12">
      <vs-row vs-w="12">
        <label for="" class="vs-input--label">Matched Score: {{selectedPriority.value}}</label>
      </vs-row>

      <vs-row vs-w="12" class="mt-2">
        <vs-select label="Priority" v-model="selectedPriority">
          <vs-select-item
            v-for="priority in tablePriorities"
            :key="'priority-' + priority.name"
            :value="priority"
            :text="priority.name"
          />
        </vs-select>
      </vs-row>
    </vs-col>


  </vs-row>
</template>

<script>

import { SeatingStrategyPreferredSeating } from "@/store/modules/marcom/data-model/seating-strategies/index.js";
export default {
  components: {
  },
  props: {
    seatingStrategy: Object,
  },
  data() {
    return {
      tablePriorities: SeatingStrategyPreferredSeating.defaultValues(),
    };
  },
  computed: {
    selectedPriority: {
      get() {
        if (this.seatingStrategy) {
          let priority = this.tablePriorities.find(
            (tp) => tp.value === this.seatingStrategy.matchScoreModifier
          );
          if (priority) return priority;
        }

        return this.tablePriorities[0];
      },
      set(priority) {
        this.seatingStrategy.matchScoreModifier = priority.value;
      },
    },
  },
  methods: {
  },
};
</script>
